import type { Id, Profile } from '../lib/types';

// v2 §D4: single source of truth for which theme key applies to a given
// (profile, routine?) pair. Per-routine override wins, otherwise the
// profile default. Centralised so step 4's per-routine picker can wire
// up everything in one place; today every caller passes `routineId` as
// undefined and gets the default.
export function resolveThemeKey(profile: Profile, routineId?: Id): string {
  if (routineId !== undefined) {
    const override = profile.theme.perRoutine?.[routineId];
    if (override) return override;
  }
  return profile.theme.default;
}
